jQuery(document).ready(function ($) {
	$('.slider-block').each(function () {
		const $slider = $(this);
		const arrowColor = $slider.closest('[data-arrow-color]').data('arrow-color') || '#ff6a00';
		const sliderType = $slider.closest('[data-slider-type]').data('slider-type');

		if (sliderType === 'multiple') {
			$slider.owlCarousel({
				loop: false,
				margin: 30,
				nav: true,
				dots: false,
				navText: [
					`<i class="fa-regular fa-arrow-left" style="color: ${arrowColor};"></i>`,
					`<i class="fa-regular fa-arrow-right" style="color: ${arrowColor};"></i>`
				],
				responsive: {
					0: {
						items: 1,
						stagePadding: 70,
					},
					600: {
						items: 2,
						stagePadding: 70,
					},
					1025: {
						items: 2,
						stagePadding: 100,
					},
					1930: {
						items: 3,
						stagePadding: 100,
					},
				},
			});
		} else {

			$slider.owlCarousel({
				loop: false,
				margin: 30,
				nav: true,
				items: 1,
				dots: false,
				navText: [
					`<i class="fa-regular fa-arrow-left" style="color: ${arrowColor};"></i>`,
					`<i class="fa-regular fa-arrow-right" style="color: ${arrowColor};"></i>`
				],
			});
		}
	});
});
